import { mapState, mapGetters } from "vuex";

const TradukojTranslatable = {
  install(Vue) {
    Vue.mixin({
      computed: {
        ...mapState({
          $active_langtag: state => state.i18nmap.active_langtag,
        }),
        ...mapGetters("i18nmap", ["getPublicLangtagCategoriesMessages"]),
      },
      methods: {
        $tradukojTranslate(translatable) {
          if (!translatable) {
            return "";
          }

          // Texto traducible via key, la traducción debe ser recibida
          // y guardada previamente en state.i18n
          if (translatable.text && translatable.namespace) {
            let translated_text = this.$t(translatable.text);
            if (translatable.text != translated_text) {
              return translated_text;
            }
          }
          // Texto traducible usando las traducciones proporcionadas
          // en el propio objeto
          else if (
            translatable.translations &&
            translatable.translations[this.$active_langtag]
          ) {
            return translatable.translations[this.$active_langtag];
          }

          if (translatable.fallback) {
            return translatable.fallback;
          }

          return "";
        },
        $formatDate(timestamp) {
          const options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          };
          const date = new Date(timestamp);
          // Damos formato a los langtag que vengan mal
          let langtag = this.$active_langtag;
          langtag = langtag.replace("_", "-");
          return date.toLocaleDateString(langtag, options);
        },
      },
    });
  },
};

export default TradukojTranslatable;
